<template>
    <div class="container-fluid signup" style="background:url('static/assets/images/login/bg1.jpg');">
        <div class="row ">
            <div class="col-sm-5 signup-box align-self-center">
                <div class="row align-content-center no-gutters">
                    <div class="title-heading">
                         <img class="login-logo" src="static/assets/images/mfs-logo.png" alt="">
                    </div>
                    <div class="text-left mt-4" v-if="currentServerDate.getTime() > applicationEndDate.getTime() || currentServerDate.getTime() < applicationStartDate.getTime()">
                      <h5 class="alert alert-success" v-if="currentServerDate.getTime() < applicationStartDate.getTime()"> {{$t('registration.lblStartReg')}} <b>{{applicationStartDate | formatDate}}</b></h5>
                      <h5 class="alert alert-danger" v-if="currentServerDate.getTime() > applicationEndDate.getTime()">{{$t('registration.lblEndReg')}} <b> {{applicationEndDate | formatDate}}</b></h5>
                       <button type="button" class="btn btn-default mt-4" @click="cancel">{{ $t('registration.buttonType.cancel') }}</button>
                    </div>
                    <div class="col-sm-12" v-else>
                        <form   data-vv-scope="signUpForm" novalidate>
                            <div class="form-group custom-form">
                                <label>{{ $t('registration.fullName') }}</label>
                                <input class="form-control" :disabled="otpResent" :class="{'uppercase': signUpForm.personalDetails.fullName,  'input' : true, 'is-success': !errors.has('signUpForm.fullName')}" ref="txt_fullname" type="text" v-validate="'required|alpha_spaces'" name="fullName" v-model="signUpForm.personalDetails.fullName" :placeholder="$t('registration.placeholder.fullname')">
                                <small v-show="errors.has('signUpForm.fullName')"  :class="{'help':!signUpForm.personalDetails.fullName, 'padbot' : signUpForm.personalDetails.fullName}" class="red is-danger">{{ errors.first('signUpForm.fullName') }}</small>
                            </div>
                            <div class="form-group custom-form">
                                <label>{{ $t('registration.email') }}</label>
                                <input class="form-control" :disabled="otpResent" :class="{'lowercase': signUpForm.userName,'input' : true, 'is-success': !errors.has('signUpForm.email')&& isUsernameAvailable}" type="signUpForm" @focusout="checkUsernameAvailability" v-validate="'required|email'" name="email" v-model="signUpForm.userName"  @input="signUpForm.userName = $event.target.value.toLowerCase()" :placeholder="$t('registration.placeholder.email')">
                                <small v-show="errors.has('signUpForm.email')" class="red help is-danger">{{errors.first('signUpForm.email')}}</small>
                            </div>
                            <div class="form-group custom-form" v-if="!otpResent">
                                <label>{{ $t('registration.confirmEmail') }}</label>
                                <input class="form-control" :disabled="otpResent" :class="{'lowercase': signUpForm.confirmEmail,'input' : true, 'is-success': !errors.has('signUpForm.confirm email')&& isUsernameAvailable}" type="signUpForm" @focusout="validateEmail" v-validate="'required|email'" name="confirm email" v-model="confirmEmail" @input="confirmEmail = $event.target.value.toLowerCase()" @paste="pasteValue"  :placeholder="$t('registration.placeholder.confirmEmail')">
                                <small v-show="errors.has('signUpForm.confirm email')" class="red help is-danger">{{errors.first('signUpForm.confirm email')}}</small>
                            </div>
                            <div class="form-group custom-form">
                                <label>{{ $t('registration.password') }}</label>
                                <div class="input-group">
                                <input class="form-control" :disabled="otpResent" :class="{'input': true}" id="txt_password" type="password" name="password" v-validate="'required'" @keypress="passwordChanged" v-model="signUpForm.password" :placeholder="$t('registration.placeholder.password')">
                                <span class="pcss input-group-addon"> 
                                  <span title="Show Password" @click="showHidePassword" v-if="!isShowPass">
                                    <i class="mdi mdi-eye-off"></i>
                                  </span>
                                  <span title="Hide Password" @click="showHidePassword" v-if="isShowPass">
                                    <i class="mdi mdi-eye"></i>
                                  </span>
                                </span>
                                </div>
                                <small class="help" v-show="!errors.has('signUpForm.password')" id="strength"></small> 
                                <small v-show="errors.has('signUpForm.password')" class="red help is-danger"> {{errors.first('signUpForm.password') }}</small>
                            </div>
                            <div class="form-group custom-form">
                                <label>{{ $t('registration.mobile') }}</label>
                                <div class="input-group">
                                  <input class="form-control mr-3" @keyup.enter="trigger" max="10" maxlength="10" oninput="this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;" type="number" id="txt_mobNo" @focusout="mobileNoChanged" v-validate="'required|regex:^([0-9]{10})$|numeric'" name="mobile" v-model="signUpForm.contactDetails.phoneNo" :placeholder="$t('registration.placeholder.mobile')">
                                  <input type="button" v-if="!otpResent" class="btn btn-default-alt input-group-addon" id="sendOtpButton" :disabled="otpSent" @click="sendOTP" :value="$t('registration.buttonType.sendOTP')">
                                  <input type="button" v-if="otpResent" class="btn btn-default-alt input-group-addon" id="resendButton" :disabled="otpSent" @click="sendOTP" :value="$t('registration.buttonType.resendOTP')">
                                </div>
                                <small v-show="errors.has('signUpForm.mobile')" class="red help is-danger">{{ errors.first('signUpForm.mobile') }}</small>
                            </div>
                            <div v-if="otpSent" class="form-group custom-form"> 
                              <label>{{ $t('registration.otp') }}</label>  
                              <div class="input-group">
                                <input type="number" name="otp" class="form-control mr-3" max="6" maxlength="6" oninput="this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;" placeholder="Enter OTP" v-validate="'required|regex:^([0-9]{6})$|numeric'" v-model="otp">
                                <small class="green"><i>{{$t('registration.otpResendNote')}}</i> <b><i id="demo">00.00s</i></b></small>
                              </div>
                                <small v-show="errors.has('signUpForm.otp')" class="red help is-danger">{{ errors.first('signUpForm.otp') }}</small>
                            </div>
                        </form>
                        <button type="button" :disabled="!otpSent" class="btn btn-orange mt-2" id="registerButton" @click="verifyOTP">{{ $t('registration.buttonType.register') }}</button>
                        <button type="button" class="btn btn-default mt-2" @click="cancel">{{ $t('registration.buttonType.cancel') }}</button>
                    </div>
                </div>
            </div>
            <div class="logo-box">
          <img class="mkcl-logo" src="static/assets/images/logo_mkcl-s.png" alt="">
          <img class="mkcl-logo right" :src="getLogoUrl(universityConfig.abbr)" alt="">
          </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'signup',
  data () {
    return {
      signUpForm: {
        contactDetails: {
          phoneNo: null,
          mobileNo: null
        },
        personalDetails: {
          fullName: null
        },
        userName: null,
        password: null
      },
      isUsernameAvailable: false,
      confirmEmail: '',
      isShowPass: false,
      otp: '',
      tempMobileNumber: 0,
      universityConfig: { state: {} },
      otpSent: false,
      otpResent: false,
      otpTimeInMin: 0,
      stopCountDown: false,
      applicationStartDate: '',
      applicationEndDate: '',
      currentServerDate: ''
    }
  },
  methods: {
    getLogoUrl (abbr) {
      return 'static/assets/images/' + abbr + '.png'
    },
    getProjectConfig () {
      // This method get university configuration
      axios.get('o/projectConfig/getUniversityConfig').then(response => {
        this.universityConfig = response.data
      }).catch(function (e) {
        console.error(e)
      })
      // This method get application start date and end date.
      axios.get('o/projectConfig/getStartEndDate').then(responses => {
        this.applicationEndDate = new Date(responses.data.endDate)
        this.applicationStartDate = new Date(responses.data.startDate)
        axios.get('o/projectConfig/getCurrentServerDateTime').then(response => {
          this.currentServerDate = new Date(response.data)
        }).catch(function (e) {
          console.error(e)
        })
      }).catch(function (e) {
        console.error(e)
      })
      // This method get otp time configuration
      axios.get('o/projectConfig/getResendOtpTimeInMin').then(response => {
        this.otpTimeInMin = parseInt(response.data)
      }).catch(function (e) {
        console.error(e)
      })
    },
    validateEmail () {
      if (this.signUpForm.userName !== this.confirmEmail) {
        this.$toasted.error(this.$t('registration.alerts.EMAIL_NOT_MATCHED'))
        this.confirmEmail = ''
        return false
      }
    },
    pasteValue () {
      window.setTimeout(() => {
        this.confirmEmail = ''
      })
    },
    checkUsernameAvailability () {
      var self = this
      if (self.signUpForm.userName !== '' && self.signUpForm.userName !== null) {
        self.signUpForm.userName = self.signUpForm.userName.toLowerCase()
        this.$validator.validate('signUpForm.email', self.signUpForm.userName).then((result) => {
          if (result) {
            axios
              .post('o/isUsernameAvailable', self.signUpForm).then(function (response) {
                if (response.status === 200) {
                  self.isUsernameAvailable = false
                  self.errors.remove('username')
                  // self.$toasted.info(self.$t('registration.alerts.USERNAME_NOT_AVAILABLE'))
                }
                if (response.status === 207) {
                  self.isUsernameAvailable = true
                  self.$toasted.info(self.$t('registration.alerts.USERNAME_ALREADY_EXIST'))
                  self.signUpForm.userName = ''
                }
              }).catch(function () {
                self.isUsernameAvailable = false
                self.$toasted.error(self.$t('registration.alerts.FAIL_TO_FIND_USERNAME_AVAILABILITY'))
              })
          } else {
            self.$toasted.error(self.$t('registration.toastrPleaseEnterValidEmail'))
          }
        })
      }
    },
    validateInput () {
      var self = this
      this.$validator.validate('signUpForm.fullName', self.signUpForm.personalDetails.fullName).then((result) => {
        if (!result) {
          this.$toasted.error(self.$t('registration.toastrPleaseEnterValidFullName'))
        }
      })
      this.$validator.validate('signUpForm.password', self.signUpForm.password).then((result) => {
        if (!result) {
          this.$toasted.error(self.$t('registration.toastrPasswordRequired'))
        }
      })
      this.$validator.validate('signUpForm.email', self.signUpForm.userName).then((result) => {
        if (!result) {
          this.$toasted.error(self.$t('registration.toastrPleaseEnterValidEmail'))
        }
      })
      this.$validator.validate('signUpForm.confirm email', self.confirmEmail).then((result) => {
        if (!result) {
          this.$toasted.error(self.$t('registration.toastrPleaseEnterValidConfirmEmail'))
        }
      })
      this.$validator.validate('signUpForm.mobile', self.signUpForm.contactDetails.phoneNo).then((result) => {
        if (!result) {
          this.$toasted.error(self.$t('registration.toastrPleaseEnterValidMobile'))
        }
      })
    },
    sendOTP () {
      var self = this
      this.stopCountDown = false
      var countDownTime = this.otpTimeInMin * 60
      this.$validator.validate().then((result) => {
        if (result) {
          if (!self.isUsernameAvailable) {
            self.signUpForm.personalDetails.fullName = (self.signUpForm.personalDetails.fullName.toUpperCase()).trim()
            self.signUpForm.userName = self.signUpForm.userName.toLowerCase()
            axios.post('o/sendotp', self.signUpForm)
              .then(function (response) {
                if (response.status === 200) {
                  self.otpResent = true
                  self.tempMobileNumber = self.signUpForm.contactDetails.phoneNo
                  self.otpSent = true
                  // setTimeout(function () {
                  //   document.getElementById('sendOtpButton').disabled = false
                  //   document.getElementById('registerButton').disabled = true
                  //   self.otpSent = false
                  // }, 600000)
                  var x = setInterval(function () {
                    countDownTime = countDownTime - 1
                    var min = Math.floor(countDownTime / 60)
                    var sec = Math.floor(countDownTime % 60)
                    var minZero = ''
                    if (min < 10) {
                      minZero = '0'
                    }
                    var secZero = ''
                    if (sec < 10) {
                      secZero = '0'
                    }
                    if (countDownTime <= 0) {
                      self.stopCountDown = true
                    }
                    if (self.stopCountDown) {
                      clearInterval(x)
                      self.otpSent = false
                    }
                    document.getElementById('demo').innerHTML = minZero + min + ':' + secZero + sec + 's'
                  }, 1000)
                  self.$toasted.success(self.$t('registration.alerts.OTP_SEND_SUCCESS'))
                }
              })
            .catch(function () {
              self.$toasted.error(self.$t('registration.alerts.OTP_Send_Fail'))
              self.otpSent = false
              self.stopCountDown = true
              // document.getElementById('sendOtpButton').disabled = false
            })
          } else {
            self.signUpForm.userName = ''
            self.stopCountDown = true
            self.$toasted.info(self.$t('registration.alerts.USERNAME_ALREADY_EXIST'))
          }
        } else {
          this.validateInput()
        }
      })
    },
    verifyOTP () {
      var self = this
      if (self.tempMobileNumber === self.signUpForm.contactDetails.phoneNo) {
        var verifyObj = {}
        verifyObj.otp = this.otp
        verifyObj.userName = this.signUpForm.userName.toLowerCase()
        this.$validator.validateAll({
          otp: this.otp,
          userName: this.signUpForm.userName
        }).then(result => {
          if (result) {
            axios.post('o/verifyotp', verifyObj)
              .then(function (response) {
                if (response.status === 200) {
                  if (response.data === true) {
                    self.register()
                  } else {
                    self.$toasted.error(self.$t('registration.alerts.OTP_INVALID'))
                  }
                }
              })
              .catch(function () {
                self.$toasted.error(self.$t('registration.alerts.OTP_VERIFY_FAIL'))
              })
          } else {
            self.$toasted.error(self.$t('registration.alerts.ENTER_VALID_DETAILS'))
          }
        })
      } else {
        // document.getElementById('sendButton').disabled = false
        // document.getElementById('registerButton').disabled = true
        self.otpSent = false
        self.stopCountDown = true
        self.otp = ''
        self.$toasted.info(self.$t('registration.alerts.MOBILE_NUMBER_CHANGED'))
        return false
      }
    },
    register () {
      var self = this
      if (self.otp === undefined || self.otp === null || self.otp === '') {
        self.$toasted.error(self.$t('registration.alerts.OTP_INVALID'))
        return false
      }
      this.$validator.validate().then((result) => {
        if (result) {
          self.signUpForm.personalDetails.fullName = (self.signUpForm.personalDetails.fullName.toUpperCase()).trim()
          self.signUpForm.userName = self.signUpForm.userName.toLowerCase()
          axios.post('o/signup', self.signUpForm)
            .then(function (response) {
              if (response.status === 200) {
                self.stopCountDown = true
                self.$toasted.success(self.$t('registration.alerts.REGISTRATION_SUCCESS'))
                self.$router.push({ path: '/' })
              }
            })
          .catch(function () {
            this.$toasted.error(self.$t('registration.alerts.REGISTRATION_FAIL'))
          })
        } else {
          this.validateInput()
        }
      })
    },
    mobileNoChanged () {
      var txtMobNo = document.getElementById('txt_mobNo')
      var mobRegExp = new RegExp('^[7-9][0-9]{9}$')
      if (!mobRegExp.test(txtMobNo.value)) {
        this.errors.add('mobile', 'Invalid Mobile Number')
      } else {
        this.errors.remove('mobile')
      }
    },
    passwordChanged () {
      var strength = document.getElementById('strength')
      var strongRegex = new RegExp(
        '^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$',
        'g'
      )
      var mediumRegex = new RegExp(
        '^(?=.{7,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$',
        'g'
      )
      var enoughRegex = new RegExp('(?=.{6,}).*', 'g')
      var pwd = document.getElementById('txt_password')
      if (strongRegex.test(pwd.value)) {
        strength.innerHTML = "<span style='color:green'>Strong!</span>"
      } else if (mediumRegex.test(pwd.value)) {
        strength.innerHTML = "<span style='color:orange'>Medium!</span>"
      } else if (enoughRegex.test(pwd.value)) {
        strength.innerHTML = "<span style='color:red'>Weak!</span>"
      } else {
        strength.innerHTML = '<span style="color:red">Very Weak!</span>'
      }
    },
    showHidePassword () {
      if (this.isShowPass) {
        this.isShowPass = false
        document.getElementById('txt_password').setAttribute('type', 'password')
      } else {
        this.isShowPass = true
        document.getElementById('txt_password').setAttribute('type', 'text')
      }
    },
    cancel () {
      this.stopCountDown = true
      this.$router.push({ path: '/' })
    },
    trigger () {
      this.register()
    }
  },
  created: function () {
    this.getProjectConfig()
  },
  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('DD-MMM-YYYY')
      }
    }
  }
}
</script>

<style lang="scss">
// @import 'static/assets/styles/scss/variables';

.signup {
  padding: 0;
  // background:url('static/assets/images/signup/bg1.jpg');
  margin-left: 0;
  overflow: hidden;
  position: relative;
  .login-logo{
      width: 120px;
    margin-bottom:10px;  }
  &:before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
  }

  .signup-box {
    background: #fff;
    height: 100vh;
    position: relative;
    padding: 0 100px;
    & > .row {
      height: 90vh;
    }
    &:before {
      left: 100%;
      top: 0;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-left-color: #fff;
      border-width: 60vh 35vh;
      margin-top: 0px;
    }
    .title-heading {
      margin-bottom: 1rem;
      h1 {
        text-transform: uppercase;
        font-size: 1.5rem;
      }
      p {
        color: #999;
        font-weight: 300;
        font-size:14px;
      }
    }
    .btn-default{
      &:hover{box-shadow: none;color:#555;}
    }
    .custom-form {
      border-bottom: 1px solid #eee;
      padding:5px 15px 5px 0px;
      margin-bottom: 10;
      position: relative;
      .pcss{color:#888; &:hover{color:#555;}}
      .btn-default-alt{
        background: #007bff;
            font-size: 11px;
          color: #fff;
          text-transform: uppercase;
        // background-color: #eee;
        // color:#333;
        position: relative;
        bottom:5px;
        border-radius:20px;
        
        &:hover{background: #036bdb;}
        &.btn-green{
              background: #2bbb4c;
              &:hover{background: #1ca83d;}
        }
      }
      label {
        font-size: 11px;
        color: #444;
        margin-bottom: 0;
        text-transform: uppercase;
      }
      .form-control {
        border: none;
        font-size:14px;
        padding: 0;
        color: #333;
        font-weight: 400;
        &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
            color: #999;
            font-weight: 300;
          }
          &::-moz-placeholder { /* Firefox 19+ */
            color: #999;
             font-weight: 300;
          }
       // text-transform: capitalize;
       
        &:focus {
          box-shadow: none !important;
        }
              
      }    
    }
    .user-img {
      width: 100px;
      margin-bottom: 1.5rem;
      border: 2px solid #eee;
      border-radius: 50%;
      padding: 6px;
    }
    .forgot-link {
      margin: 1rem 0;
      display: block;
      font-size: 14px;
      text-decoration: none;
      color: #999;
      font-weight: 500;
      &:hover {
        color: #007bff;
      }
      .btn-orange {
        padding: 10px 40px;
      }
    }
  }
  .help{
    position: absolute;
    bottom: -18px;
    font-size: 12px;
    color: #F44336;
  }
}
.logo-box{
    position: absolute;
    left: 10px;
    width: 46%;
    bottom: 10px;
    z-index: 111;   
    img{ height:60px; }
    .right{
      float: right;
  }
}
.uppercase{
text-transform: uppercase;
}
.lowercase{
text-transform: lowercase;
}
.padbot{
    position: absolute;
    bottom: -33px;
    font-size: 12px;
    color: #F44336;
}
.green{
    color: green;
}

// #signup {height: 100vh;}
</style>



// WEBPACK FOOTER //
// src/components/signUp/sign-up.vue